import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import { type TextBlockIndexProps, TextBlockWithQuery } from '@cx-modules/text-block';

export const TextBlock = (props: Omit<TextBlockIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <TextBlockWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
